import React, { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { AppContext } from './AppContext.tsx';
import Logo from './logo/Logo.tsx';
import KeyboardShortcut from './KeyboardShortcut.jsx';
import { getPlatformModifiers, createCrossPlatformBinding } from '../hooks/keybinding/utils.js';

const NewChatOptions = () => {
  const {
    profile,
    setSearchModal,
    toggleModelSelector,
  } = useContext(AppContext);

  const navigate = useNavigate();
  
  // Get platform-specific command palette key
  const commandPaletteKey = useMemo(() => {
    return createCrossPlatformBinding('k', { primary: true });
  }, []);
  
  const greetingText = useMemo(() => {
    const hour = new Date().getHours();
    let greeting;
    if (hour >= 6 && hour < 12) greeting = "Good morning";
    else if (hour >= 12 && hour < 18) greeting = "Good afternoon";
    else greeting = "Good evening";
    
    return profile?.firstname ? `${greeting}, ${profile.firstname}` : greeting;
  }, [profile]);

  return (
    <div className="w-full max-w-full sm:max-w-[400px] md:max-w-[768px] text-center flex flex-col gap-spacing-2 text-primary">
      <div className="flex flex-col items-center justify-center gap-spacing-8">
        <Logo
          variant="wordmark"
          text={greetingText}
          size={24}
          ariaLabel={greetingText}
          typingEnabled={true}
          showCursor={false}
        />
        <div className="w-full max-w-full sm:max-w-[400px] flex flex-col flex-nowrap justify-center items-center gap-spacing-4">
          <div className="w-full flex flex-col flex-wrap justify-center items-center gap-spacing-2">
            <div className="w-full">
              { /* Toggle command palette button */}
              <div onClick={() => setSearchModal()}
                className="w-full h-[32px] hover:cursor-pointer
                flex flex-row justify-between items-center
                rounded text-primary px-spacing-2 hover:bg-bg-hover">
                <label className="flex flex-row items-center gap-spacing-2">
                  <KeyboardShortcut sequence={commandPaletteKey} /> or <KeyboardShortcut sequence="/" />
                </label>
                <label>
                  Open command palette
                </label>
              </div>

              { /* Select model button */}
              <div onClick={() => toggleModelSelector()}
                className="w-full h-[32px] hover:cursor-pointer
                flex flex-row justify-between items-center
                rounded text-primary px-spacing-2 hover:bg-bg-hover">
                <label>
                  <KeyboardShortcut sequence="s m" />
                </label>
                <label>
                  Select model
                </label>
              </div>

              { /* Go to settings button */}
              <div onClick={() => navigate('/settings')}
                className="w-full h-[32px] hover:cursor-pointer
                flex flex-row justify-between items-center
                rounded text-primary px-spacing-2 hover:bg-bg-hover">
                <label>
                  <KeyboardShortcut sequence="g s" />
                </label>
                <label>
                  Go to settings
                </label>
              </div>
              { /* Go to usage button */}
              <div onClick={() => navigate('/usage')}
                className="w-full h-[32px] hover:cursor-pointer
                flex flex-row justify-between items-center
                rounded text-primary px-spacing-2 hover:bg-bg-hover">
                <label>
                  <KeyboardShortcut sequence="g u" />
                </label>
                <label>
                  Go to usage
                </label>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(NewChatOptions);
